
export default class StartIntegrationTestsPayload {
    labels: {
        [key: string]: string
    } = {};

    startedBy: string;

    targetPhoneNumber: string;

    constructor(userEmail: string, targetPhoneNumber: string) {
        this.startedBy = userEmail;
        this.targetPhoneNumber = targetPhoneNumber;
        this.labels['userEmail'] = userEmail;
        this.labels['targetPhoneNumber'] = targetPhoneNumber;
    }
}